import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { motion } from "framer-motion";
import "../../Styles/Admin/AttendenceOverviewChart.css";
import { API_BASE_URL } from "../../apiConfig";

const AttendanceOverviewChart = () => {
  const [attendanceData, setAttendanceData] = useState([]);

  useEffect(() => {
    const fetchAttendanceData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/admin/attendance-trend`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("idToken")}`,
          },
        });
        const data = await response.json();
        if (data.success) {
          let trend = data.trend;
          if (trend.length > 7) {
            trend = trend.slice(-7);
          }
          setAttendanceData(trend); 
        } else {
          setAttendanceData([]);
          console.error("Failed to fetch attendance data:", data.message);
        }
      } catch (err) {
        setAttendanceData([]);
        console.error("Error fetching attendance data:", err);
      }
    };

    fetchAttendanceData();
  }, []);

  return (
    <motion.div
      className="attendance-chart-container"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
    >
      <h2 className="attendance-chart-title">Attendance Overview</h2>

      <div className="attendance-chart-wrapper">
        <ResponsiveContainer width={"100%"} height={300}>
          <LineChart data={attendanceData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#4B5563" />
            <XAxis dataKey={"date"} stroke="#9ca3af" />
            <YAxis stroke="#9ca3af" />
            <Tooltip
              contentStyle={{
                backgroundColor: "rgba(31, 41, 55, 0.8)",
                borderColor: "#4B5563",
              }}
              itemStyle={{ color: "#E5E7EB" }}
            />
            <Line
              type="monotone"
              dataKey="checkIns"
              stroke="#6366F1"
              strokeWidth={3}
              dot={{ fill: "#6366F1", strokeWidth: 2, r: 6 }}
              activeDot={{ r: 8, strokeWidth: 2 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </motion.div>
  );
};

export default AttendanceOverviewChart;